<div class="ltms-information-panel" [id]="'OINF' + feedId">
  <div class="ltms-information-container">
    <section class="ltms-information-column">
      <div class="ltms-information-column-header"><div class="ltms-information-label">Profile</div></div>
      <div class="ltms-information-row" *ngFor="let detail of profileDetails">
        <div class="ltms-row-header">{{ detail.header }}</div>
        <div class="ltms-row-value">{{ detail.value }}</div>
      </div>
    </section>
    <section class="ltms-information-column">
      <div class="ltms-information-column-header"><div class="ltms-information-label">Transaction details</div></div>
      <div class="ltms-information-row" *ngFor="let detail of transactionDetails">
        <div class="ltms-row-header">{{ detail.header }}</div>
        <div class="ltms-row-value" [class.expanded]="detail.showMore">{{ detail.value }}</div>
        <button type="button" class="show-more-btn" *ngIf="detail.value.length > 120" (click)="toggleShowMore(detail)">
          {{ detail.showMore ? 'Show less' : 'Show more' }}
        </button>
      </div>
    </section>
    <section class="ltms-information-column" *ngIf="!isNotRespondedTab">
      <div class="ltms-information-column-header"><div class="ltms-information-label">Notification detail</div></div>
      <div class="ltms-information-row" *ngFor="let detail of notifactionDetails">
        <div class="ltms-row-header">{{ detail.header }}</div>
        <div class="ltms-row-value">{{ detail.value }}</div>
      </div>
    </section>
  </div>
</div>
